/**
 * accordion.js
 * Delegated toggle for [data-accordion] accordions (FAQ, product hero, etc.).
 */

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-accordion] .accordion__trigger');
  if (!trigger) return;

  var accordion = trigger.closest('[data-accordion]');
  if (!accordion) return;

  var panelId = trigger.getAttribute('aria-controls');
  var panel = panelId ? document.getElementById(panelId) : accordion.querySelector('.accordion__panel');
  if (!panel) return;

  var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
  var willExpand = !isExpanded;

  trigger.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
  panel.hidden = !willExpand;

  var plusIcon = trigger.querySelector('[data-accordion-icon="plus"]');
  var minusIcon = trigger.querySelector('[data-accordion-icon="minus"]');
  if (plusIcon) plusIcon.hidden = willExpand;
  if (minusIcon) minusIcon.hidden = !willExpand;

  var titleEl = trigger.querySelector('.accordion__title');
  var title = titleEl ? titleEl.textContent.trim() : 'Section';

  if (typeof announceToScreenReader === 'function') {
    announceToScreenReader(
      willExpand ? title + ' expanded.' : title + ' collapsed.'
    );
  }
});
